import * as yup from 'yup'

export const addMetricToExistingMetricSchema = yup.object().shape({
  id: yup.string().required(),
  includeHistory: yup.boolean().required(),
})
